import { render, staticRenderFns } from "./SuccessSlate.vue?vue&type=template&id=68ae0f02"
import script from "./SuccessSlate.vue?vue&type=script&lang=js"
export * from "./SuccessSlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports